import { render, staticRenderFns } from "./TestComponent.vue?vue&type=template&id=1b80da46&scoped=true&"
import script from "./TestComponent.vue?vue&type=script&lang=js&"
export * from "./TestComponent.vue?vue&type=script&lang=js&"
import style0 from "./TestComponent.vue?vue&type=style&index=0&id=1b80da46&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b80da46",
  null
  
)

export default component.exports